export default __webpack_public_path__ + "static/media/filter.01dc983b.svg";